export const ROUTE_CREATE = `create`
export const ROUTE_PATIENTS = `/patients`
export const ROUTE_USER_PROFILE = `/user-profile`
export const ROUTE_NEWS_WALL = `/newsWall`
export const ROUTE_NOTIFICATIONS = `/newsWall`
export const ROUTE_FORM_GENERATOR = `/form-generator`
export const ROUTE_FORM_GENERATOR_FORM = `/form-generator/form`
export const ROUTE_FORM_GENERATOR_FORM_EDIT = `/form-generator/form/:id`
export const ROUTE_FORM_GENERATOR_FORM_CREATE = `/form-generator/form/create`
export const ROUTE_FORM_GENERATOR_FORM_RESULTS = `/form-generator/form/:id/results`
export const ROUTE_FORM_GENERATOR_USERS = `/form-generator/:id/users`
export const ROUTE_FORM_GENERATOR_ASSIGNTO = `/form-generator/:id/assignTo`
export const ROUTE_PATIENT_FORMS = `/forms`
export const ROUTE_PATIENT_FORMS_VIEW = `/forms/:id`
export const ROUTE_CONFIGURATION = `/configuration`
export const ROUTE_RESOURCES = `/resources`
export const ROUTE_RESOURCES_ID = `/resources/:id`
export const ROUTE_RESOURCES_SHARED_WITH_ME = `/resources/shared`
export const ROUTE_RESOURCES_SHARED_WITH_ME_ID = `/resources/shared/:id`
export const ROUTE_RESOURCES_FORM = `/resources/form`
export const ROUTE_RESOURCES_FORM_EDIT = `/resources/form/:id`
export const ROUTE_STATISTICS = `/statistics`
export const ROUTE_STATISTICS_ID = `/statistics/:id`
export const ROUTE_NOTIFICATIONS_CONFIG = `/notifications-config`
export const ROUTE_ROLE_PERMISSIONS = `/role-permissions`
export const ROUTE_USERS_CREATE = `/users/createParticipant`
export const ROUTE_USERS_CREATE_ID = `/users/createParticipant/:id`
export const ROUTE_USER_DETAIL = `/users/profile/:id`
export const ROUTE_LOGIN = '/login'
export const ROUTE_DASHBOARD = '/users/dashboard'
export const ROUTE_DASHBOARD_ID = '/users/dashboard/:id'
export const ROUTE_USER_FORMS = '/users/forms/'
export const ROUTE_PRIVACY_POLICY = '/policy'
export const ROUTE_COOKIES_POLICY = '/cookies'
export const ROUTE_PROTOCOLS = '/protocols'
// "Protocol Management" del menu: crear un protocolo desde cero. Va antes que
// el detalle porque @reach/router da prioridad a los segmentos estaticos sobre
// los dinamicos, asi que "new" no se confunde con un :id.
export const ROUTE_PROTOCOL_NEW = '/protocols/new'
export const ROUTE_PROTOCOL_DETAIL = '/protocols/:id'
